export const pricingData = [
    {
        product: "https://cdn.blackincae.com/respoclear-resize/Uyq-3-bottle-pm.png",
        title: "3 Bottles",
        subtitle: "90 Days Supply",
        pricePerBottle: 49,
        totalBottles: 3,
        buttonLink: 'https://upsender21_scalerespo.pay.clickbank.net/?cbitems=7&cbur=a',
        originalPrice: 597,
        leastpopular: true,
        popular: false,
        discountedPrice: 147,
        freeshipping:'FAST & FREE SHIPPING',
    },
    {
        product: "https://cdn.blackincae.com/respoclear-resize/OMx-9-bottle-pm.png",
        title: "9 Bottles",
        buttonLink: 'https://upsender21_scalerespo.pay.clickbank.net/?cbitems=8&cbur=a',
        subtitle: "270 Days Supply",
        pricePerBottle: 29,
        totalBottles: 12,
        originalPrice: "1,791",
        discountedPrice: 261,
        leastpopular: false,
        popular: true,
        discount:' Biggest discount',
        freeshipping:'FAST & Free Shipping',
        bonuses:'2 BONUSES',
        bestValue: true,
    },
    { 
        product: "https://cdn.blackincae.com/respoclear-resize/I7B-6-bottle-pm.png",
        title: "6 Bottles ",
        buttonLink: ' https://upsender21_scalerespo.pay.clickbank.net/?cbitems=9&cbur=a',
        subtitle: "180 Day Supply",
        pricePerBottle: 39,
        totalBottles: 6,
        originalPrice: 1194,
        discountedPrice: 234,
        leastpopular: false,
        popular: false,
        freeshipping:'FAST & Free Shipping',
        bonuses:'2 BONUSES',
    }
]